// Copyright 2025 Sorama B.V.

import { bindable, computedFrom, customElement } from "aurelia-framework";
import { Reportable, ReportableMeasurement } from "datatypes/ReportableMeasurement";
import { SorXData, SorXPDDData } from "datatypes/SorXMeasurement";

@customElement("sorx-pdd-overview-template")
export class SorPDDOverviewTemplate {
    private currentDate = Date.now();
    private notAvailableString = "";

    @bindable
    public reportList: Reportable[] = [];
    @bindable
    public reportListChunk: Reportable[] = [];
    @bindable
    public lastOverviewPage: number;

    @bindable
    public pageNumber: number;

    @bindable
    public maxPages: number;

    public get showAssetName(): boolean {
        return this.reportList.some(
            (report) => (report as ReportableMeasurement<SorXPDDData & SorXData>).data.tagAssetName
        );
    }

    public get showAssetID(): boolean {
        return this.reportList.some(
            (report) => (report as ReportableMeasurement<SorXPDDData & SorXData>).data.tagAssetID
        );
    }

    // Get earliest inspection date from all reports
    @computedFrom("reportList", "reportList.length")
    public get inspectionDate(): Date {
        if (!this.reportList || this.reportList.length === 0) {
            return new Date();
        }
        const dates = this.reportList.map((reportable) => {
            const report = reportable as ReportableMeasurement<SorXPDDData>;
            return report.created;
        });

        if (dates.length === 0) {
            return new Date();
        }
        return new Date(Math.min(...dates.map((date) => date.getTime())));
    }

    public async bind(): Promise<void> {}
}
